import React from 'react';
import Column from 'shared/components/column';
import Pressable from 'shared/components/pressable';
import Row from 'shared/components/row';
import {LightText, MediumText, SemiBoldText} from 'shared/components/text';

interface Props {
  title: string;
  description?: string;
  onClick?: () => void;
  buttonLabel: string;
  extraComponent?: React.ReactNode;
  icon: React.ReactNode;
}

const CartAction: React.FC<Props> = ({
  title,
  description,
  onClick,
  buttonLabel,
  icon,
  extraComponent,
}) => {
  return (
    <Row justifyContent="space-between" gap={10}>
      {icon}
      <Column style={{flex: 1}}>
        <SemiBoldText>{title}</SemiBoldText>
        {description && <LightText size="small">{description}</LightText>}
      </Column>
      <Pressable {...{onClick}}>
        <Row gap={5}>
          {extraComponent}
          {!extraComponent && (
            <MediumText color="primary">{buttonLabel}</MediumText>
          )}
        </Row>
      </Pressable>
    </Row>
  );
};

export default CartAction;
